import * as Yup from "yup";

import { SaleStatus, SaleStatusLabels } from "constants/sale";

export const SaleStatusValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(50)
    .required("Required!")
    // (name "Draft", archetype DRAFT) is the reserved "no status" sentinel.
    .test(
      "not-reserved-draft",
      '"Draft" with the Draft archetype is reserved to mean "no status". Use a different name or archetype.',
      function isNotReservedDraftSentinel(value) {
        return !(
          this.parent.archetype === SaleStatus.DRAFT &&
          (value || "").trim().toLowerCase() ===
            SaleStatusLabels[SaleStatus.DRAFT].toLowerCase()
        );
      },
    ),
  archetype: Yup.string().required("Required!"),
  saleType: Yup.string().nullable(),
});
